import * as p from '@clack/prompts'
import path from 'node:path'
import type { UninstallCommandOptions } from '@cli-types/core-engine/commands.js'
import { DEFAULT_ADMIN_NAMESPACE } from '@cli-constants/scaffolding.js'
import { spinner } from '@cli-utils/terminal.js'
import { resolveConfig } from '@next-adapter/config/resolve-config.js'
import pc from 'picocolors'
import { buildUninstallPlan } from './build-uninstall-plan.js'

export async function runUninstallCommand(options: UninstallCommandOptions): Promise<void> {
  const cwd = options.cwd ? path.resolve(options.cwd) : process.cwd()

  p.intro(pc.bgRed(pc.white(' BetterStart Uninstall ')))

  let namespace = DEFAULT_ADMIN_NAMESPACE
  try {
    const config = await resolveConfig(cwd)
    namespace = config.frameworkConfig.next.namespace
  } catch {}
  const steps = buildUninstallPlan(cwd, namespace)

  if (steps.length === 0) {
    p.log.success(`${pc.green('✓')} Nothing to remove — project is already clean.`)
    p.outro('Project already clean')
    return
  }

  const planLines = steps.map((step) => {
    const names = step.items.join(' ')
    const countLabel = pc.dim(`${step.count} ${step.unit}`)
    return `${pc.red('✗')} ${names}  ${countLabel}`
  })
  p.note(planLines.join('\n'), 'Uninstall plan')

  if (!options.force) {
    const confirmed = await p.confirm({
      message: 'Proceed with uninstall?',
      initialValue: false
    })

    if (p.isCancel(confirmed) || !confirmed) {
      p.cancel('Uninstall cancelled.')
      process.exit(0)
    }
  }

  const s = spinner()
  s.start(steps[0]!.label)
  for (const step of steps) {
    s.message(step.label)
    step.execute()
  }
  const parts = steps.map((step) => `${step.count} ${step.unit}`)
  s.stop(`Removed ${parts.join(', ')}`)

  p.note(pc.dim('Database tables were NOT dropped — drop them manually if needed.'), 'Next steps')

  p.outro('Uninstall complete')
}
